module.exports = __webpack_public_path__ + "static/media/PALOSANTO_04.05b90000.png";